import {
  LOCAL_STORAGE,
  LOCAL_STORAGE_TRUE,
  OPEN_STRIPE_CHECKOUT
} from 'constants/general';

export const saveMarkerIndicatingUserOpenedStripe = () => {
  localStorage.setItem(OPEN_STRIPE_CHECKOUT, LOCAL_STORAGE_TRUE);
};

export const getLocalStorage = (key: string) => {
  return localStorage.getItem(key);
};

export const getLocalStorageItems = (keys: string[]) => {
  return keys.map((key) => localStorage.getItem(key));
};

export const removeLocalStorage = (keys: string[]) => {
  keys.forEach((key) => localStorage.removeItem(key));
};

export const updateLocalStorage = (key: string, value: string) => {
  localStorage.setItem(key, value);
};

export const getItemsLocalStorage = (keys: string[]) => {
  return keys.map((key) => getLocalStorage(key));
};

export const clearLocalStorage = () => {
  localStorage.clear();
};

export const clearLocalStorageKeysByPrefix = (prefix: string) => {
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key && key.startsWith(prefix)) {
      localStorage.removeItem(key);
      i--;
    }
  }
};

export const clearDesktopSignInSession = (): void => {
  try {
    [
      LOCAL_STORAGE.AUTH_BEARER_TOKEN_DESKTOP,
      LOCAL_STORAGE.DESKTOP_SIGNIN_IN_PROGRESS
    ].map((key) => sessionStorage.removeItem(key));
  } catch (error) {
    console.warn('Error clearing session data:', error);
  }
};
